import { useState, useEffect } from 'react';
import { getNumberOfOrganizations } from "../../../APIs/auditor_dashboard";

const useNumberOfOrganizations = (filters, setLoading) => {
    const [data, setData] = useState(0);

    const fetchNumberOfOrganizations = async () => {
        try {
            setLoading(true);
            const response = await getNumberOfOrganizations(filters);
            setData(response.data.count);
        } catch (error) {
            console.error('Error fetching number of orgs:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNumberOfOrganizations();
    }, [filters]);

    return data;
};

export default useNumberOfOrganizations;
